import { ActionStatusType } from '../types/ActionStatusType';
import { FooterSettings } from '../types/FooterSettings';
import ApiProvider  from './ApiProvider';

const FooterApi = {
  fetchFooterSettings: async () => {
    return await ApiProvider.get<ActionStatusType<FooterSettings>>(
      'FooterModule/GetFooter'
    );
  }
};

export default FooterApi;
